// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1931":"837794aa","8047":"5b5b6af6"}[chunkId] + ".chunk.css";
};